import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { EditBranchInstallationsReqData } from "./EditBranchInstallationsReqData";

const ENDPOINT = "/branch";

export class EditBranchInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "patch";
    params: EditBranchInstallationsReqData;

    constructor(params: EditBranchInstallationsReqData) {
        super();
        this.endPoint += `/${params.branchId}/installations`;
        this.params = params;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.params);
        return new ApiGenericResponse(res);
    }
}
